import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { BrowserRouter, Switch, Route, NavLink, useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import OkCancelAlertModal from 'web/components/OkCancelAlertModal';
import DashBoardIcon from '../../../assets/images/dashboard.png'
import UserManagementIcon from '../../../assets/images/user-management.png'
import ReportsIcon from '../../../assets/images/reports.png'
import DisputeIcon from '../../../assets/images/dispute-copy-5.png'
import SubscriptionIcon from '../../../assets/images/subsciption-copy-3.png'
import ContentModerationIcon from '../../../assets/images/content-moderation-copy-4.png'
import UserIcon from '../../../assets/images/user_page.png'
import QuotesImage from '../../../assets/images/quotesImage.png'
import LanguageLacalizationIcon from '../../../assets/images/language_localization.png'
import PromoCodeIcon from '../../../assets/images/promo_code.png'
import LogoIcon from '../../../assets/images/headerMobileLogo.png'
import DashBoard from './DashBoard'
import Users from './User'
import PostModule from './PostsModule'
import UserInfo from './UserInfo'
import UserActivity from './UserActivity'
import LocationManagement from './LocationManagement'
import NewInvitations from './NewInvitations'
import Subscription from './Subscription'
import Claim from './Claim'
import Quotes from './Quotes';
import Reports from './Reports'
import PromoCode from './PromoCode'
import ReferralCode from './ReferralCode'
import AppNonUser from './AppNonUser'
import RetryOrders from './RetryOrders'
import CancelOrders from './CancelOrders'
import LanguageLocalization from './LanguageLocalization'
import TermsAndConditions from './TermsAndConditions'
import ChatBlock from './ChatBlock'
import OrderChatList from './OrderChats'
import SubscriptionReport from './Reports/Tables/SubscriptionReport'
import PurchaseReport from './Reports/Tables/PurchaseReport'
import OrderReport from './Reports/Tables/OrderReport'
import PickupOrderReport from './Reports/Tables/PickupOrderReport'
import ClaimReport from './Reports/Tables/ClaimReport'
import PostLoadReport from './Reports/Tables/PostLoadReport'
import ReferralReport from './Reports/Tables/ReferralReport'
import CommissionReport from './Reports/Tables/CommissionReport'
import UserSubscriptionList from './DashBoard/Charts/UserSubscriptionList'
import OrderDetailList from './DashBoard/Charts/OrderDetailList'
import ContentModeration from './ContentModeration'
import AdminCustomerReviews from './CustomerReviews'
import PTPlusUserManagement from './PTPlus/UserManagement'
import PTPlusOrderRequestManagement from './PTPlus/OrderRequestsManagement';
import PTPlusOrderRequest from './PTPlus/OrderRequest';
import PTPlusRequestPickupOrder from './PTPlus/RequestPickupOrder';
import Invoices from "./PTPlus/Invoices/index.js"
import PTPlusReports from "./PTPlus/Reports/index.js"
import PTPlusBuyBackFeeRequest from "./PTPlus/BuyBackFeeRequests"
import PTPlusVendorPricing from "./PTPlus/VendorPricing"

import { Wrapper, Sidebar, MainSection, Header, Body, HeaderLogo, UserName } from './adminStyled';
import { CgLogOff } from "react-icons/cg";
import { storeAdminDetails, fetchAllChatList, claimListNotification, updateClaimNotificationApi } from 'redux/actions/admin';
import RefreshTokenHOC from 'web/components/RefreshTokenHOC';

import { adminDashboardRequestCountApi, adminResCenterRequestCountApi, requestOrderCountApi } from 'redux/actions/notificationCount';
import { ExportOrderReport, csvOrderReportHeaderArray } from 'redux/actions/helper/csvExport/exportOrderReport';
import { ExportPickupOrderReport, csvPickupOrderReportHeaderArray } from 'redux/actions/helper/csvExport/exportPickUpOrderReport';
import CsvDownloader from 'react-csv-downloader';
import YesNoModal from 'web/components/YesNoModal';
import { needsColumns, invColumns } from "../Admin/PostsModule/Constants";
import { ExportPostVisibility } from 'redux/actions/helper/csvExport/exportPostVisibility';
import { ExportPtPlusOrderReport, ptPlusOrderReportCSVHeaderArray, ptPlusPickupOrderReportCSVHeaderArray } from 'redux/actions/helper/csvExport/exportPtPlusOrderReport';
import { ExportPtPlusBuyBackReport, ptPlusBuyBackCSVHeaderArray } from 'redux/actions/helper/csvExport/exportBuyBackReport';
import { ExportPtPlusVendorPricingReport, ptPlusVendorPricingCSVHeaderArray } from 'redux/actions/helper/csvExport/exportVendorPricingReport';
import useRefreshToken from 'web/components/RefreshTokenHOC/useRefreshToken';

const Admin = () => {
  let dispatch = useDispatch()
  let history = useHistory()
  const divRef = useRef()
  const [screenWidth, setscreenWidth] = useState("web")
  const [openMenu, setOpenMenu] = useState(true);
  const handleClick = () => setOpenMenu(!openMenu);
  const [openMenuMobile, setOpenMenuMobile] = useState(false);
  const handleClickMobile = () => setOpenMenuMobile(!openMenuMobile);
  const adminRoles = useSelector(state => state.admin.adminRoles)
  const adminInfo = useSelector(state => state.admin.adminInfo)
  const token = localStorage.getItem('token')

  const adminDashboardRequestsNotifCount = useSelector((state) => state.notificationCount?.adminDashboardRequestsNotifCount)
  const adminResCenterNotifCount = useSelector((state) => state.notificationCount?.adminResCenterNotifCount)
  const ptPlusRequestsOrderCount = useSelector((state) => state.notificationCount?.ptPlusRequestsOrderCount)

  const [claimMessageCount, setClaimMessageCount] = useState(0)
  const [chatMessageCount, setChatMessageCount] = useState(0)
  const [claimNotificationMessage, setclaimNotificationMessage] = useState(false)
  const [modal, setModal] = useState(false);
  const [alertType, setAlertType] = useState('')
  const [modalContent, setModalContent] = useState('')
  const toggleModal = () => {
    setModal(!modal)
    if (claimNotificationMessage) {
      updateClaimNotificationMessage()
    }
  }

  const [expandPtPlusUser, setExpandPtPlusUser] = useState(false)

  useEffect(() => {
    let userRole = localStorage.getItem('accountType')
    let appUserRolesList = ['Both', 'Buyer', 'Seller', 'Reseller']
    if (userRole !== 'Admin') {
      if (appUserRolesList.includes(userRole)) history.push('/dashboard')
      else history.push('/sign-in')
      window.location.reload();
    }
  }, [])

  useEffect(() => {
    const adminRoles = localStorage.getItem('adminRolesData')
    const adminInfo = { name: localStorage.getItem('adminName'), email: localStorage.getItem('adminEmail') }
    dispatch(storeAdminDetails(adminRoles, adminInfo))

    const intervalCall = setInterval(() => {
      dispatch(adminDashboardRequestCountApi());
      dispatch(adminResCenterRequestCountApi());
      dispatch(requestOrderCountApi());
    }, 10000)

    return () => {
      clearInterval(intervalCall)
    }
  }, [])

  useEffect(() => {
    // check new messages in claim or chat section
    const intervalCall = setInterval(() => {
      checkNewMessage()
    }, 60000);
    window.addEventListener('resize', setwindowSize())
    return () => {
      clearInterval(intervalCall)
      window.removeEventListener('resize', setwindowSize())
    }
  }, [])

  const setwindowSize = () => {
    if (window.innerWidth > 1024) setscreenWidth("web")
    else setscreenWidth("mobile")
  }

  const updateClaimNotificationMessage = async () => {
    let updateClaimNotification = await dispatch(updateClaimNotificationApi())
  }

  const checkNewMessage = async () => {
    let claimResponse = '';
    let chatResponse = '';
    // claimResponse = await dispatch(adminClaimListforCount());
    chatResponse = await dispatch(fetchAllChatList());
    if (chatResponse.message === "Missing request header 'authId' for method parameter of type String") {
      history.push('/sign-in');
    }
    let claimNotificationMessage = await dispatch(claimListNotification())
    setclaimNotificationMessage(claimNotificationMessage?.payload)
    let tempclaimMessageCount = 0
    let tempchatMessageCount = 0
    if (claimResponse.status === 'SUCCESS' && claimResponse.payload && claimResponse.payload.length > 0) {
      let tempdata = claimResponse.payload
      tempclaimMessageCount = tempdata.reduce((acc, val) => {
        let tempCount = 0
        const { adminResolutionThread } = val
        if (adminResolutionThread && adminResolutionThread !== null) {
          tempCount = adminResolutionThread.filter(val => (!val.readByAdmin && val.readByAdmin !== null)).length
        }
        return acc + tempCount
      }, 0)
      setClaimMessageCount(tempclaimMessageCount)
    }
    if (chatResponse.status === 'SUCCESS' && chatResponse.payload && chatResponse.payload.length > 0) {
      let tempdata = chatResponse.payload
      tempchatMessageCount = tempdata.reduce((acc, val) => {
        let tempCount = 0
        const { chatMessages } = val
        if (chatMessages && chatMessages !== null) {
          tempCount = chatMessages.filter(val => (!val.readByAdmin && val.readByAdmin !== null)).length
        }
        return acc + tempCount
      }, 0)
      setChatMessageCount(tempchatMessageCount)
    }
  }

  // to compare previous and current state value to identify which dependency has changed
  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }
  const prevMessageCount = usePrevious({ claimMessageCount, chatMessageCount });

  useEffect(() => {
    if (claimNotificationMessage && chatMessageCount > prevMessageCount.chatMessageCount) {
      setAlertType('adminBothMessageCount')
      setModalContent('There are new messages in the claim and chat section')
      setModal(true)
    } else if (claimNotificationMessage) {
      setAlertType('adminClaimMessageCount')
      setModalContent('There are new messages in the claim section')
      setModal(true)
    } else if (prevMessageCount && chatMessageCount > prevMessageCount.chatMessageCount) {
      setAlertType('adminChatMessageCount')
      setModalContent('There are new messages in the chat section')
      setModal(true)
    }
  }, [claimNotificationMessage, chatMessageCount])

  const [yesNoModalOpen, setYesNoModalOpen] = useState(false);
  const yesNoToggleModal = () => setYesNoModalOpen(!yesNoModalOpen);
  const adminLogout = () => {
    if (isDownloadingOrderReportCSV || isDownloadingPostVisibilityCSV) {
      yesNoToggleModal();
    } else {
      // Continue with the logout process
      localStorage.removeItem('token');
      history.push('/sign-in');
    }
  };

  const notificationCountStyle = { position: 'absolute', bottom: '-2px', fontSize: '9px', padding: '5px', background: '#69BBE0', color: '#000', borderRadius: '45%', minWidth: '22px', textAlign: 'center' }
  const notificationCountStyleOrderReq = { position: 'absolute', bottom: '28px', fontSize: '9px', padding: '7px 4px 4px 3px', background: ' rgb(105, 187, 224)', color: 'rgb(0, 0, 0)', borderRadius: '45%', height: '24px', width: '27px', textAlign: 'center' }
  
  const sideBarList = () => {
    return (
      <>
        <div onClick={() => setOpenMenuMobile(false)}>
          {adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('DASHBOARD_ADMIN')) && <li>
            <NavLink exact={true} activeClassName='active' to="/admin"><img src={DashBoardIcon} alt="" />Dashboard {adminDashboardRequestsNotifCount > 0 && <div style={{ position: 'relative' }}><span style={notificationCountStyle}>{adminDashboardRequestsNotifCount}</span></div>}</NavLink>
          </li>}
        </div>

        {adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('PT_PLUS')) && <li>
          <h5 style={{ cursor: 'pointer', position: 'relative' }} onClick={() => setExpandPtPlusUser(!expandPtPlusUser)}>
            <img style={{ marginRight: '24px' }} src={UserIcon} alt="Admin" />
            PT+ Admin {ptPlusRequestsOrderCount > 0 && <span style={notificationCountStyleOrderReq}>{ptPlusRequestsOrderCount}</span>}
            <i></i></h5>
          {expandPtPlusUser && <div onClick={() => {
            let obj = {
              id: null,
              items: null
            };

            dispatch({ type: "REQUESTED_ID", payload: obj });
            setOpenMenuMobile(false)
          }} className='ptplus-user-manage'>
            <NavLink to="/ptplus-user-managememt">Account Management</NavLink>
            <NavLink to="/ptplus-buyback-fee">Vendor Buyback</NavLink>
            <NavLink to="/ptplus-vendor-pricing">Vendor Pricing</NavLink>
            <NavLink to="/ptplus-order-request-managememt">Order Requests{ptPlusRequestsOrderCount > 0 && <div style={{ position: 'relative' }}><span style={notificationCountStyle}>{ptPlusRequestsOrderCount}</span></div>}</NavLink>
            <NavLink to="/ptplus-invoices">Invoice</NavLink>
            <NavLink to="/ptplus-reports">Reports</NavLink>
            <NavLink to="/ptplus-order-request">Create Order Request</NavLink>
            <NavLink to="/ptplus-admin-request-pickup-order">Create Pickup Request</NavLink>
          </div>
          }
        </li>}

        <div onClick={() => setOpenMenuMobile(false)}>
          {adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('USER_MANAGEMENT')) && <li>
            <NavLink to="/users"><img src={UserIcon} alt="" />User Management</NavLink>
          </li>}
          {adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('USERACTIVITY_ADMIN')) && <li>
            <NavLink to="/user-activity"><img src={UserManagementIcon} alt="" />User Activity</NavLink>
          </li>}
          {adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('LOCATION_MANAGEMENT')) && <li>
            <NavLink to="/location-management"><img src={UserManagementIcon} alt="" />Location Management</NavLink>
          </li>}
          {adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('NEW_INVITATIONS')) && <li>
            <NavLink to="/new-invitations"><img src={SubscriptionIcon} alt="" />New Invitations</NavLink>
          </li>}
          {adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('USER_REPORTS')) && <li>
            <NavLink to="/reports"><img src={ReportsIcon} alt="" />Reports</NavLink>
          </li>}
          {/* {adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('POSTS')) && <li>
                        <NavLink to="/admin-posts"><img src={ReportsIcon} alt="" />Posts</NavLink>
                    </li>} */}
          {adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('POST_VISIBILITY')) && <li>
            <NavLink to="/admin-post-module"><img src={ReportsIcon} alt="" />Post Visibility</NavLink>
          </li>}
          {adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('RETRY_ORDERS')) && <li>
            <NavLink to="/retry-orders"><img src={DisputeIcon} alt="" />Retry Orders</NavLink>
          </li>}
          {adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('CANCEL_ORDERS')) && <li>
            <NavLink to="/cancel-orders"><img src={DisputeIcon} alt="" />Cancel Orders</NavLink>
          </li>}
          {adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('RESOLUTION_CENTER_ADMIN')) && <li>
            <NavLink to="/claim"><img src={DisputeIcon} alt="" />Resolution Center {adminResCenterNotifCount > 0 && <div style={{ position: 'relative' }}><span style={notificationCountStyle}>{adminResCenterNotifCount}</span></div>}</NavLink>
          </li>}
          {adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('QUOTES')) && <li>
            <NavLink to="/quotes"><img src={QuotesImage} alt="" />Quotes</NavLink>
          </li>}
          {adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('SUBSCRIPTION_ADMIN')) && <li>
            <NavLink to="/subscription"><img src={SubscriptionIcon} alt="" />Subscription</NavLink>
          </li>}
          {adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('CONTENT_MODERATION_ADMIN')) && <li>
            <NavLink to="/content-moderation"><img src={ContentModerationIcon} alt="" />Content Moderation</NavLink>
          </li>}
          {adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('PROMO_CODE')) && <li>
            <NavLink to="/promo-code"><img src={PromoCodeIcon} alt="" />Promo Code</NavLink>
          </li>}
          {adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('REFERRAL_CODE')) && <li>
            <NavLink to="/referral-code"><img src={PromoCodeIcon} alt="" />Referral Code</NavLink>
          </li>}
          {adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('APPLICATION_NON_USERS')) && <li>
            <NavLink to="/app-non-user"><img src={PromoCodeIcon} alt="" />Application Non Users</NavLink>
          </li>}
          {adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('LANGUAGE_LOCALIZATION')) && <li>
            <NavLink to="/language-localization"><img src={LanguageLacalizationIcon} alt="" />Language Localization</NavLink>
          </li>}
          {adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('TERMS_AND_CONDITONS')) && <li>
            <NavLink to="/terms-and-conditions"><img src={LanguageLacalizationIcon} alt="" />Terms and Conditions</NavLink>
          </li>}
          {adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('ORDER_CHAT') || adminRoles.includes('CHAT')) && <li>
            <NavLink to="/chats-order"><img src={LanguageLacalizationIcon} alt="" />Order Chats</NavLink>
          </li>}
          {adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('CHAT') || adminRoles.includes('ORDER_CHAT')) && <li>
            <NavLink to="/chat-block"><img src={LanguageLacalizationIcon} alt="" />Chat</NavLink>
          </li>}
        </div>
      </>
    )
  }

  const adminRoutes = () => {
    return (
      <Body ref={divRef}>
        <Switch>
          <Route path="/admin">
            <DashBoard />
          </Route>
          <Route path="/userSubscriptionList">
            <UserSubscriptionList />
          </Route>
          <Route path="/user-activity">
            <UserActivity />
          </Route>
          <Route path="/location-management">
            <LocationManagement />
          </Route>
          <Route path="/orderDetailList">
            <OrderDetailList />
          </Route>
          <Route path="/users">
            <Users />
          </Route>
          <Route path="/detailedUserInfo">
            <UserInfo />
          </Route>
          <Route path="/new-invitations">
            <NewInvitations />
          </Route>
          <Route path="/reports">
            <Reports />
          </Route>
          <Route path="/subscriptionReports">
            <SubscriptionReport />
          </Route>
          <Route path="/purchaseReports">
            <PurchaseReport />
          </Route>
          <Route path="/orderReports">
            <OrderReport downloadReportCSV={downloadReportCSV} isDownloadingOrderReportCSV={isDownloadingOrderReportCSV} />
          </Route>
          <Route path="/pickupOrderReports">
            <PickupOrderReport downloadPickupOrderReportCSV={downloadPickupOrderReportCSV} isDownloadingPickupOrderReportCSV={isDownloadingPickupOrderReportCSV} />
          </Route>
          <Route path="/claimReports">
            <ClaimReport />
          </Route>
          <Route path="/loadInventoryReports">
            <PostLoadReport />
          </Route>
          <Route path="/referralsReports">
            <ReferralReport />
          </Route>
          <Route path="/commissionReport">
            <CommissionReport />
          </Route>
          <Route path="/retry-orders">
            <RetryOrders />
          </Route>
          <Route path="/cancel-orders">
            <CancelOrders />
          </Route>
          <Route path="/admin-post-module">
            <PostModule downloadPostVisibilityReportCSV={downloadPostVisibilityReportCSV} isDownloadingPostVisibilityCSV={isDownloadingPostVisibilityCSV} />
          </Route>
          <Route path="/claim">
            <Claim scrollTop={scrollTop} />
          </Route>
          <Route path="/quotes">
            <Quotes scrollTop={scrollTop} />
          </Route>
          <Route path="/subscription">
            <Subscription />
          </Route>
          <Route path="/content-moderation">
            <ContentModeration />
          </Route>
          <Route path="/adminCustomerReviews">
            <AdminCustomerReviews />
          </Route>
          <Route path="/promo-code">
            <PromoCode />
          </Route>
          <Route path="/referral-code">
            <ReferralCode />
          </Route>
          <Route path="/app-non-user">
            <AppNonUser />
          </Route>
          <Route path="/language-localization">
            <LanguageLocalization />
          </Route>
          <Route path="/terms-and-conditions">
            <TermsAndConditions />
          </Route>
          <Route path="/chats-order">
            <OrderChatList />
          </Route>
          <Route path="/chat-block">
            <ChatBlock />
          </Route>

          {/* pt plus pages */}
          <Route path="/ptplus-user-managememt">
            <PTPlusUserManagement scrollTop={scrollTop} />
          </Route>
          <Route path="/ptplus-order-request">
            <PTPlusOrderRequest scrollTop={scrollTop} />
          </Route>
          <Route path="/ptplus-admin-request-pickup-order">
            <PTPlusRequestPickupOrder scrollTop={scrollTop} />
          </Route>
          <Route path="/ptplus-order-request-managememt">
            <PTPlusOrderRequestManagement scrollTop={scrollTop} />
          </Route>
          <Route path="/ptplus-invoices">
            <Invoices scrollTop={scrollTop} />
          </Route>
          <Route path="/ptplus-reports">
            <PTPlusReports scrollTop={scrollTop} downloadPTPlusReportCSV={downloadPTPlusReportCSV} isDownloadingPtPlusOrderReportCSV={isDownloadingPtPlusOrderReportCSV} />
          </Route>
          <Route exact path="/ptplus-buyback-fee">
            <PTPlusBuyBackFeeRequest scrollTop={scrollTop} isDownloadingPtPlusBuyBackFeeCSV={isDownloadingPtPlusBuyBackFeeCSV} downloadPTPlusBuyBackFeeCSV={downloadPTPlusBuyBackFeeCSV} />
          </Route>
          <Route exact path="/ptplus-vendor-pricing">
            <PTPlusVendorPricing scrollTop={scrollTop} isDownloadingPtPlusVendorPricingCSV={isDownloadingPtPlusVendorPricingCSV} downloadPTPlusVendorPricingCSV={downloadPTPlusVendorPricingCSV} />
          </Route>
        </Switch>
        {/* modal for redirecting to claim page, if there is any new message */}
        <OkCancelAlertModal
          isOpen={modal}
          toggle={toggleModal}
          alertType={alertType}
          content={modalContent}
        />
      </Body>
    )
  }

  const scrollTop = () => {
    divRef.current.scroll({ top: 0, behavior: 'smooth' });
  }

  //pickup Order report csv export and download feature revamp
  const [isDownloadingPickupOrderReportCSV, setIsDownloadingPickupOrderReportCSV] = useState(false)
  const [pickupOrderCsvCurrentPage, setPickupOrderCsvCurrentPage] = useState(1)
  const [pickupOrderCsvTotalPages, setPickupOrderCsvTotalPages] = useState(1)
  const [csvPickupOrderReportData, setCsvPickupOrderReportData] = useState([])
  const downloadPickupOrderReportCSV = (filterData, currentPage, searchKey) => {
    setPickupOrderCsvCurrentPage(1)
    setPickupOrderCsvTotalPages(1)
    setCsvPickupOrderReportData([])
    ExportPickupOrderReport(filterData, currentPage, searchKey, setPickupOrderCsvCurrentPage, setPickupOrderCsvTotalPages, setIsDownloadingPickupOrderReportCSV, setCsvPickupOrderReportData)
  }

  //Order report csv export and download feature revamp
  const [isDownloadingOrderReportCSV, setIsDownloadingOrderReportCSV] = useState(false)
  const [csvCurrentPage, setCsvCurrentPage] = useState(1)
  const [csvTotalPages, setCsvTotalPages] = useState(1)
  const [csvOrderReportData, setCsvOrderReportData] = useState([])
  const downloadReportCSV = (filterData, currentPage, searchKey) => {
    setCsvCurrentPage(1)
    setCsvTotalPages(1)
    setCsvOrderReportData([])
    ExportOrderReport(filterData, currentPage, searchKey, setCsvCurrentPage, setCsvTotalPages, setIsDownloadingOrderReportCSV, setCsvOrderReportData)
  }

  //Post visibility export data revamp
  const [isDownloadingPostVisibilityCSV, setIsDownloadingPostVisibilityCSV] = useState(false)
  const [csvPostVisibilityCurrentPage, setCsvPostVisibilityCurrentPage] = useState(0)
  const [csvPostVisibilityTotalPages, setCsvPostVisibilityTotalPages] = useState(1)
  const [csvPostVisibilityData, setCsvPostVisibilityData] = useState([])
  const [activePostType, setActivePostType] = useState("")
  const downloadPostVisibilityReportCSV = (multiSelectCompanyVal, postType, requestFilter, bidStatusType, tableSearch, filterType, userFilterState, dispatch) => {
    setActivePostType(postType)
    setCsvPostVisibilityCurrentPage(0)
    setCsvPostVisibilityTotalPages(1)
    setCsvPostVisibilityData([])
    ExportPostVisibility(multiSelectCompanyVal, postType, requestFilter, bidStatusType, tableSearch, filterType, userFilterState, dispatch, setIsDownloadingPostVisibilityCSV, setCsvPostVisibilityData, csvPostVisibilityCurrentPage, setCsvPostVisibilityCurrentPage, setCsvPostVisibilityTotalPages)

  }

  //PTPlusOrder report csv export and download feature
  const [isDownloadingPtPlusOrderReportCSV, setIsDownloadingPtPlusOrderReportCSV] = useState(false)
  const [ptPlusOrderCsvCurrentPage, setPtPlusOrderCsvCurrentPage] = useState(0)
  const [ptPlusCsvTotalPages, setPtPlusCsvTotalPages] = useState(1)
  const [ptPlusCsvOrderReportHeader, setPtPlusCsvOrderReportHeader] = useState(ptPlusOrderReportCSVHeaderArray)
  const [ptPlusCsvOrderReportData, setPtPlusCsvOrderReportData] = useState([])
  const downloadPTPlusReportCSV = (multiSelectCompanyVal, tabValue, tableSearch, userFilterState, dispatch) => {
    setPtPlusOrderCsvCurrentPage(0)
    setPtPlusCsvTotalPages(1)
    setPtPlusCsvOrderReportData([])
    if (tabValue === 'pickupOrder') setPtPlusCsvOrderReportHeader(ptPlusPickupOrderReportCSVHeaderArray)
    else setPtPlusCsvOrderReportHeader(ptPlusOrderReportCSVHeaderArray)
    ExportPtPlusOrderReport(multiSelectCompanyVal, tabValue, tableSearch, userFilterState, setIsDownloadingPtPlusOrderReportCSV, setPtPlusCsvOrderReportData, ptPlusOrderCsvCurrentPage, setPtPlusOrderCsvCurrentPage, setPtPlusCsvTotalPages, dispatch)
  }

  //PTPlusOrder BuyBackFee csv export and download feature
  const [isDownloadingPtPlusBuyBackFeeCSV, setIsDownloadingPtPlusBuyBackFeeCSV] = useState(false)
  const [ptPlusBuyBackrCsvCurrentPage, setPtPlusBuyBackCsvCurrentPage] = useState(0)
  const [ptPlusBuyBackCsvTotalPages, setPtPlusBuyBackCsvTotalPages] = useState(1)
  const [ptPlusCsvBuyBackReportData, setPtPlusCsvBuyBackReportData] = useState([])
  const downloadPTPlusBuyBackFeeCSV = (filter, tableSearch, dispatch) => {
    setPtPlusOrderCsvCurrentPage(0)
    setPtPlusCsvTotalPages(1)
    setPtPlusCsvOrderReportData([])
    ExportPtPlusBuyBackReport(filter, tableSearch, setIsDownloadingPtPlusBuyBackFeeCSV, setPtPlusCsvBuyBackReportData, ptPlusBuyBackrCsvCurrentPage, setPtPlusBuyBackCsvCurrentPage, setPtPlusBuyBackCsvTotalPages, dispatch)
  }

  //PTPlusOrder vendor pricing csv export and download feature
  const [isDownloadingPtPlusVendorPricingCSV, setIsDownloadingPtPlusVendorPricingCSV] = useState(false)
  const [ptPlusVendorPricingCsvCurrentPage, setPtPlusVendorPricingCsvCurrentPage] = useState(0)
  const [ptPlusVendorPricingCsvTotalPages, setPtPlusVendorPricingCsvTotalPages] = useState(1)
  const [ptPlusCsvVendorPricingReportData, setPtPlusCsvVendorPricingReportData] = useState([])
  const downloadPTPlusVendorPricingCSV = (filter, tableSearch, dispatch) => {
    setPtPlusVendorPricingCsvCurrentPage(0)
    setPtPlusVendorPricingCsvTotalPages(1)
    setPtPlusCsvVendorPricingReportData([])
    ExportPtPlusVendorPricingReport(filter, tableSearch, setIsDownloadingPtPlusVendorPricingCSV, setPtPlusCsvVendorPricingReportData, ptPlusVendorPricingCsvCurrentPage, setPtPlusVendorPricingCsvCurrentPage, setPtPlusVendorPricingCsvTotalPages, dispatch)
  }

  useRefreshToken();
  
  return (
    <Wrapper>
      <Helmet
        title="Admin | PalletTrader">
      </Helmet>
      {/*<RefreshTokenHOC />*/}
      {(token && adminRoles) ?
        <BrowserRouter>
          <Sidebar>
            <nav style={{ height: '100%' }}>
              <HeaderLogo className={openMenu ? 'webView' : 'leftLogo webView'}>
                <img src={LogoIcon} />
                <div className='openMenuIcon'>
                  <svg viewBox="0 0 100 100" width="35" onClick={handleClick} className={!openMenu ? 'ham ham2' : ' ham ham2 active'}>
                    <path
                      className="line top"
                      d="m 70,33 h -40 c -6.5909,0 -7.763966,-4.501509 -7.763966,-7.511428 0,-4.721448 3.376452,-9.583771 13.876919,-9.583771 14.786182,0 11.409257,14.896182 9.596449,21.970818 -1.812808,7.074636 -15.709402,12.124381 -15.709402,12.124381" />
                    <path
                      className="line middle"
                      d="m 30,50 h 40" />
                    <path
                      className="line bottom"
                      d="m 70,67 h -40 c -6.5909,0 -7.763966,4.501509 -7.763966,7.511428 0,4.721448 3.376452,9.583771 13.876919,9.583771 14.786182,0 11.409257,-14.896182 9.596449,-21.970818 -1.812808,-7.074636 -15.709402,-12.124381 -15.709402,-12.124381" />
                  </svg>
                </div>

              </HeaderLogo>
              {/* for mobile view */}
              <HeaderLogo className={openMenuMobile ? 'mobileView' : 'leftLogo mobileView'}>
                <img src={LogoIcon} />
                <div className='openMenuIcon'>
                  <svg viewBox="0 0 100 100" width="35" onClick={handleClickMobile} className={!openMenuMobile ? 'ham ham2' : ' ham ham2 active'}>
                    <path
                      className="line top"
                      d="m 70,33 h -40 c -6.5909,0 -7.763966,-4.501509 -7.763966,-7.511428 0,-4.721448 3.376452,-9.583771 13.876919,-9.583771 14.786182,0 11.409257,14.896182 9.596449,21.970818 -1.812808,7.074636 -15.709402,12.124381 -15.709402,12.124381" />
                    <path
                      className="line middle"
                      d="m 30,50 h 40" />
                    <path
                      className="line bottom"
                      d="m 70,67 h -40 c -6.5909,0 -7.763966,4.501509 -7.763966,7.511428 0,4.721448 3.376452,9.583771 13.876919,9.583771 14.786182,0 11.409257,-14.896182 9.596449,-21.970818 -1.812808,-7.074636 -15.709402,-12.124381 -15.709402,-12.124381" />
                  </svg>
                </div>
              </HeaderLogo>
              <ul className='navListStyle webView'>
                {sideBarList()}
              </ul>

              {/* for mobile view */}
              <ul className='navListStyle mobileView'>
                {sideBarList()}
              </ul>
            </nav>
          </Sidebar>

          {/* A <Switch> looks through its children <Route>s and
                      renders the first one that matches the current URL. */}
          <MainSection className={openMenu ? 'sideBarActive webView' : 'sideBarNonActive webView'}>

            {isDownloadingOrderReportCSV && csvTotalPages > 1 && (
              <p className='px-4 text-right alert alert-info my-0'>
                Generating Order Report CSV... <b>{((csvCurrentPage / csvTotalPages) * 100).toFixed(2)}% Completed.</b>
              </p>
            )}
            {isDownloadingPickupOrderReportCSV && pickupOrderCsvTotalPages > 1 && (
              <p className='px-4 text-right alert alert-info my-0'>
                Generating Order Report CSV... <b>{((pickupOrderCsvCurrentPage / pickupOrderCsvTotalPages) * 100).toFixed(2)}% Completed.</b>
              </p>
            )}
            {isDownloadingPostVisibilityCSV && csvPostVisibilityTotalPages > 1 && (
              <p className='px-4 text-right alert alert-info my-0'>
                Generating Post Visibility CSV... <b>{(((csvPostVisibilityCurrentPage + 1) / csvPostVisibilityTotalPages) * 100).toFixed(2)}% Completed.</b>
              </p>
            )}
            {isDownloadingPtPlusOrderReportCSV && ptPlusCsvTotalPages > 1 && (
              <p className='px-4 text-right alert alert-info my-0'>
                Generating PT-Plus Order Report CSV... <b>{(((ptPlusOrderCsvCurrentPage + 1) / ptPlusCsvTotalPages) * 100).toFixed(2)}% Completed.</b>
              </p>
            )}
            <CsvDownloader
              style={{ display: "none" }}
              id='csvExportRef'
              filename="Order Report"
              columns={csvOrderReportHeaderArray}
              datas={csvOrderReportData}>
              <button
                style={{ background: '#27911b', color: 'white', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '5px' }}>
                Export
              </button>
            </CsvDownloader>

            <CsvDownloader
              style={{ display: "none" }}
              id='csvPickupOrderExportRef'
              filename="Pickup Order Report"
              columns={csvPickupOrderReportHeaderArray}
              datas={csvPickupOrderReportData}>
              <button
                style={{ background: '#27911b', color: 'white', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '5px' }}>
                Export
              </button>
            </CsvDownloader>

            <CsvDownloader
              style={{ display: "none" }}
              id='csvPostVisibilityExportRef'
              filename={activePostType === "NEED" ? "Posted Needs Report" : "Posted Inventories Report"}
              columns={activePostType === "NEED" ? needsColumns : invColumns}
              datas={csvPostVisibilityData}>
              <button
                style={{ background: '#27911b', color: 'white', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '5px' }}>
                Export
              </button>
            </CsvDownloader>

            <CsvDownloader
              style={{ display: "none" }}
              id='ptPlusOrderRportCsvExportRef'
              filename="PT Plus Order Report"
              columns={ptPlusCsvOrderReportHeader}
              datas={ptPlusCsvOrderReportData}>
              <button
                style={{ background: '#27911b', color: 'white', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '5px' }}>
                Export
              </button>
            </CsvDownloader>

            <CsvDownloader
              style={{ display: "none" }}
              id='ptPlusBuyBackCsvExportRef'
              filename="PT Plus BuyBack CSV"
              columns={ptPlusBuyBackCSVHeaderArray}
              datas={ptPlusCsvBuyBackReportData}>
              <button
                style={{ background: '#27911b', color: 'white', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '5px' }}>
                Export
              </button>
            </CsvDownloader>

            <CsvDownloader
              style={{ display: "none" }}
              id='ptPlusVendorPricingCsvExportRef'
              filename="PT Plus Vendor Pricing CSV"
              columns={ptPlusVendorPricingCSVHeaderArray}
              datas={ptPlusCsvVendorPricingReportData}>
              <button
                style={{ background: '#27911b', color: 'white', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '5px' }}>
                Export
              </button>
            </CsvDownloader>

            <Header>
              <svg viewBox="0 0 100 100" width="35" onClick={handleClick} className={!openMenu ? 'ham ham2' : ' ham ham2 active'}>
                <path
                  className="line top"
                  d="m 70,33 h -40 c -6.5909,0 -7.763966,-4.501509 -7.763966,-7.511428 0,-4.721448 3.376452,-9.583771 13.876919,-9.583771 14.786182,0 11.409257,14.896182 9.596449,21.970818 -1.812808,7.074636 -15.709402,12.124381 -15.709402,12.124381" />
                <path
                  className="line middle"
                  d="m 30,50 h 40" />
                <path
                  className="line bottom"
                  d="m 70,67 h -40 c -6.5909,0 -7.763966,4.501509 -7.763966,7.511428 0,4.721448 3.376452,9.583771 13.876919,9.583771 14.786182,0 11.409257,-14.896182 9.596449,-21.970818 -1.812808,-7.074636 -15.709402,-12.124381 -15.709402,-12.124381" />
              </svg>

              <CgLogOff
                onClick={adminLogout}
                title='Logout' style={{ marginRight: '10px', height: '40px', width: '27px', cursor: 'pointer' }} />
              <div>
                <UserName><h3>{adminInfo && adminInfo.name}</h3><p>Admin</p></UserName>
              </div>
            </Header>
            {screenWidth === "web" && adminRoutes()}
          </MainSection>

          {/* for mobile view */}
          <MainSection className={openMenuMobile ? 'sideBarActive mobileView' : 'sideBarNonActive mobileView'}>
            <Header>
              <svg viewBox="0 0 100 100" width="35" onClick={handleClickMobile} className={!openMenuMobile ? 'ham ham2' : ' ham ham2 active'}>
                <path
                  className="line top"
                  d="m 70,33 h -40 c -6.5909,0 -7.763966,-4.501509 -7.763966,-7.511428 0,-4.721448 3.376452,-9.583771 13.876919,-9.583771 14.786182,0 11.409257,14.896182 9.596449,21.970818 -1.812808,7.074636 -15.709402,12.124381 -15.709402,12.124381" />
                <path
                  className="line middle"
                  d="m 30,50 h 40" />
                <path
                  className="line bottom"
                  d="m 70,67 h -40 c -6.5909,0 -7.763966,4.501509 -7.763966,7.511428 0,4.721448 3.376452,9.583771 13.876919,9.583771 14.786182,0 11.409257,-14.896182 9.596449,-21.970818 -1.812808,-7.074636 -15.709402,-12.124381 -15.709402,-12.124381" />
              </svg>

              <CgLogOff
                onClick={adminLogout}
                title='Logout' style={{ marginRight: '10px', height: '40px', width: '27px', cursor: 'pointer' }} />
              <div>
                <UserName><h3>{adminInfo && adminInfo.name}</h3><p>Admin</p></UserName>
              </div>
            </Header>
            {screenWidth === "mobile" && adminRoutes()}
          </MainSection>
        </BrowserRouter>
        : adminLogout()
      }
      <YesNoModal
        isOpen={yesNoModalOpen}
        toggle={yesNoToggleModal}
        title=""
        onClickHander={(val) => {
          if (val === "no") {
            localStorage.removeItem('token');
            history.push('/sign-in');
          } else {
            yesNoToggleModal()
          }
        }}
        content="The CSV file is currently being prepared for download. Would you like to proceed with exporting the file?"
        link="/"
      />
    </Wrapper>)
};

export default Admin;
